// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class SubmenuToggle extends WebComponent {
  constructor(props) {
    super(props);
    this.handleMobileTapEvents = this.handleMobileTapEvents.bind(this);
    this.handleLinkMobileTapEvents = this.handleLinkMobileTapEvents.bind(this);
    this.handleClickEvents = this.handleClickEvents.bind(this);
    this.timeout = null;
  }

  didMount() {
    //check for touch devices
    function is_touch_enabled() {
      return ( 'ontouchstart' in window ) ||
        ( navigator.maxTouchPoints > 0 ) ||
        ( navigator.msMaxTouchPoints > 0 );
    }
    this.submenu = this.element;
    this.mobileLink = this.element.querySelector('.submenu__toggle');
    this.mobileTrigger = this.element.querySelector('.submenu__toggle-mobile');
    this.submenuPopUp = this.element.querySelector('.submenu__popup');

    if(this.submenu) {
      if(is_touch_enabled()){ // on touch screeens
        this.mobileLink.addEventListener('touchstart', this.handleLinkMobileTapEvents);
        this.mobileTrigger.addEventListener('touchstart', this.handleMobileTapEvents);

      }else { // on desktops
        this.mobileTrigger.addEventListener('click', this.handleClickEvents);
      }
    }
  }

  willUnMount() {}

  // triggering submenu on mobiles and small screens
  handleMobileTapEvents (e) {
    if (e.cancelable) {
      e.preventDefault();
    }
    this.submenu.classList.toggle('active');
    this.mobileTrigger.classList.toggle('active');
    this.submenuPopUp.classList.toggle('active');
  };
  handleLinkMobileTapEvents (e) {
    if(window.innerWidth <= 991 && !this.submenu.classList.contains('active')) {
      e.preventDefault();
      this.submenu.classList.toggle('active');
      this.mobileTrigger.classList.toggle('active');
      this.submenuPopUp.classList.toggle('active');
    }
  };

  // handling click events
  handleClickEvents (e) {
    this.submenu.classList.toggle('active');
    this.mobileTrigger.classList.toggle('active');
    this.submenuPopUp.classList.toggle('active');
  };
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SubmenuToggle.js